interface Config {
  backendUrl: string;
  walkingSpeed: number;
  startingBounds: [[number, number], [number, number]];
  opacity: number;
  padding: number;
  maxTravelMins: number;
  defaultMaxMinutes: number;
  colours: string[];
  wheelPxPerZoomLevel: number;
}

const backendUrl = process.env.REACT_APP_DEV
  ? "http://localhost:3001/"
  : "https://tfl-travel-time-backend-polished-log-1447.fly.dev/";

console.log("Backend URL:", backendUrl);

const config: Config = {
  backendUrl: backendUrl,
  walkingSpeed: 80,
  startingBounds: [
    [51.564956, -0.263222],
    [51.452705, 0.022491],
  ],
  opacity: 0.4,
  padding: 300,
  // Upper limit of the settings slider.
  maxTravelMins: 100,
  defaultMaxMinutes: 60,
  // The fixed travel-time bands, fastest first; thresholds are spaced
  // evenly up to the max travel time from the settings slider.
  colours: [
    "#007FFF",
    "#00FFFF",
    "#93b516",
    "#FFFF00",
    "#FF7F00",
    "#FF0000",
    "#7F0000"
  ],
  wheelPxPerZoomLevel: 800,
};

export default config;
